import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import s from './Chat.module.css';
// import loupe from './../../assets/icons/loupe.svg';
import ChatPanel from './ChatPanel/ChatPanel';
import Member from './Member/Member';
import ChatixSDK from './ChatixSDK';
import {setChatroomTitleAC, setChatroomMembersAC, setMeAC, setChatroomMessagesAC, sendMessageAC} from './../../redux/actions/chat';

const Chat = () => {
    const chatroomId = 'f1e6e26e-d305-450d-acca-dbf8ccc85071';
    const dispatch = useDispatch();
    const {isAuth, userName, userPhotoURL} = useSelector(({auth}) => auth);
    const {members} = useSelector(({chat}) => chat);

    const memberList = members.map(member => <Member key={member.uuid} name={member.name} is_online={member.is_online}/>);


    //Работа с Chatix.SDK

    const chatixSDK = React.createRef();

    const updateChatroomTitle = (roomTitle) => {
        dispatch(setChatroomTitleAC(roomTitle));
    }

    const setChatroomMembers = (allChatroomMembers) => {
        allChatroomMembers.sort(sortMembers);

        function sortMembers(a, b) {
            if (a.is_online === true && b.is_online === false) {
            return -1;
            } else if (b.is_online === true && a.is_online === false) {
            return 1;
            } else {
            if (a.name && b.name) {
                if (a.name.toLocaleUpperCase() > b.name.toLocaleUpperCase()) {
                return 1;
                } else if (a.name.toLocaleUpperCase() < b.name.toLocaleUpperCase()) {
                return -1;
                }
            } else if (a.name && !b.name) {
                return -1;
            } else if (!a.name && b.name) {
                return 1;
            } 
            if (a.uuid > b.uuid) {
                return -1;
            } else {
                return 1;
            }
            }
        }

        const newStateFragment = { members: members};
        dispatch(setChatroomMembersAC(newStateFragment));
    }

    const setMe = (me) => {
        // console.log(me);
    }

    const setChatroomMessages = (lastMessages) => {
        dispatch(setChatroomMessagesAC(lastMessages));
    }

    const onSendNewMessage = async (message) => {
        let receivedMsg = await chatixSDK.current.sdk.sendChatroomTextMessage(message, chatroomId);
        dispatch(sendMessageAC(receivedMsg));
    }

    const onUpdateVisitor = (user) => {
        chatixSDK.current.updateVisitor(user)
        this.setMe(user)
        let currentUser = this.state.members.find((member) => (member.uuid === user.uuid))
        let currentUserIndex = this.state.members.indexOf(currentUser)
        let newMembers = [...this.state.members]
        newMembers[currentUserIndex] = user;
        this.setState({
          members: newMembers
        })
    }

    return (
        <>
        {isAuth 
        ? 
        <div className={s.chatWrapper}>
            <div className={s.chat}>
                <nav className={s.navPanel}>
                    <div className={s.userBlock}>
                        <div className={s.userImage}>
                            <img src={userPhotoURL} alt="..."/>
                        </div>
                        <div className={s.userInfo}>
                            <div className={s.userName}>{userName}</div>
                            <div className="userProf">React Developer</div>
                        </div>
                    </div>
                    <div className={s.searchBlock}>
                        <input type="text" placeholder="Search..."/>
                    </div>
                    <div className={s.channelsAndMessages}>
                        <div className="channelBlock">
                            <div className="channelTitle">
                                <h6>Users</h6>
                            </div>
                            {memberList}
                        </div>
                    </div>
                </nav>
                <ChatPanel onSendNewMessage={onSendNewMessage}/>
                <ChatixSDK 
                    ref={chatixSDK}
                    updateChatroomTitle={updateChatroomTitle} 
                    setChatroomMembers={setChatroomMembers}
                    setMe={setMe}
                    setChatroomMessages={setChatroomMessages}/>
            </div>
        </div>
        : <Redirect to={"/login"}/>
        }
        </>
    )
}

export default Chat


